import { assign } from 'xstate5';

import { logger as garnishLogger } from '@garnish/logger';

import { Action, type FetchReceiptResponse } from '../receipt.machine.types';

// ─── Actions ─────────────────────────────────────────────────────────────────

const assignReceiptData: Action<FetchReceiptResponse> = assign((_args, output) => {
  const { receipt } = output;

  if (receipt?.__typename !== 'Receipt') {
    return {};
  }

  const order = receipt.order;

  return { order };
});

const assignError: Action = assign(({ event }) => {
  const raw = 'error' in event ? event.error : 'Unknown error';
  const message = raw instanceof Error ? raw.message : String(raw);

  return { error: message };
});

// ─── Log Actions ─────────────────────────────────────────────────────────────

const logSuccessfulClaim: Action = (args) => {
  const { order, receiptId } = args.context;

  if (!order || !receiptId) return;

  receiptMachineLog.info(
    ['Successfully claimed a receipt', `Order ID: ${order.id}`, `Receipt ID: ${receiptId}`].join(
      ' | ',
    ),
  );
};

const logFailedClaim: Action = (args) => {
  const { order, receiptId } = args.context;

  if (!order || !receiptId) return;

  receiptMachineLog.error(
    ['Failed to claimed a receipt', `Order ID: ${order.id}`, `Receipt ID: ${receiptId}`].join(
      ' | ',
    ),
  );
};

const logFailedClaimDueToUserError: Action = (args) => {
  const { order, receiptId } = args.context;

  receiptMachineLog.warn(
    [
      'User error: Receipt claim failure',
      `Order ID: ${order?.id}`,
      `Receipt ID: ${receiptId}`,
    ].join(' | '),
  );
};

// ─── External Actions ────────────────────────────────────────────────────────

const onSuccessfulClaim: Action = () => {};
const onAlreadyClaimed: Action = () => {};
const onExpired: Action = () => {};
const onNotFound: Action = () => {};
const onUnknownError: Action = () => {};

// ─────────────────────────────────────────────────────────────────────────────

export const Actions = {
  assignReceiptData,
  assignError,

  onSuccessfulClaim,
  onAlreadyClaimed,
  onExpired,
  onNotFound,
  onUnknownError,

  logSuccessfulClaim,
  logFailedClaim,
  logFailedClaimDueToUserError,
};

// ─── Logger ───────────────────────────────────────────────────────────────────

garnishLogger.enable('RECEIPT_MACHINE');

export const receiptMachineLog = garnishLogger.extend('RECEIPT_MACHINE');
